import styled from 'styled-components';

export const CourseCardWrapper = styled.article`
  width: 100%;
  max-width: 340px;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  background: var(--white);

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadiusLarge);

  box-shadow: var(--shadow-md);

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-3px);

    border-color: var(--orange6);

    box-shadow: var(--shadow-lg);
  }
`;

export const CourseCardTop = styled.div`
  min-height: 290px;

  padding: var(--space-l);

  display: flex;
  flex-direction: column;

  background: linear-gradient(135deg, var(--orange7) 0%, var(--white) 72%);
`;

export const CourseLanguage = styled.p`
  width: fit-content;

  margin: 0 0 var(--space-m);

  padding: 0.38rem 0.65rem;

  background: rgba(254, 254, 254, 0.78);

  border: 1px solid rgba(234, 154, 38, 0.15);
  border-radius: var(--borderRadiusSmall);

  color: var(--orange5);

  font-size: 0.72rem;
  font-weight: 800;

  line-height: 1;

  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const CourseTitle = styled.h3`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.55rem, 2vw, 2rem);
  font-weight: 900;

  line-height: 1.08;
  letter-spacing: -0.035em;
`;

export const CourseDescription = styled.p`
  margin: var(--space-m) 0 0;

  display: -webkit-box;

  overflow: hidden;

  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  color: var(--grey5);

  font-size: 0.92rem;
  font-weight: 500;

  line-height: 1.55;
`;

export const CourseInfoRow = styled.div`
  width: 100%;

  margin-top: auto;
  padding-top: var(--space-l);

  display: flex;
  flex-wrap: wrap;

  gap: var(--space-m) var(--space-l);

  border-top: 1px solid rgba(81, 81, 81, 0.12);
`;

export const CourseInfoItem = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: 0.2rem;
`;

export const CourseInfoLabel = styled.span`
  color: var(--grey3);

  font-size: 0.68rem;
  font-weight: 800;

  line-height: 1.2;

  letter-spacing: 0.07em;
  text-transform: uppercase;
`;

export const CourseInfoValue = styled.span`
  color: var(--grey6);

  font-size: 0.85rem;
  font-weight: 650;

  line-height: 1.35;
`;

export const CourseCardBottom = styled.div`
  width: 100%;

  padding: var(--space-m) var(--space-l);

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: var(--space-m);

  background: var(--white);

  border-top: 1px solid var(--grey1);
`;

export const CoursePrice = styled.p`
  margin: 0;

  color: var(--grey7);

  font-size: 1.35rem;
  font-weight: 900;

  line-height: 1;
  letter-spacing: -0.025em;
`;

export const CourseButton = styled.button`
  min-height: 42px;

  padding: 0.65rem 1rem;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 0.45rem;

  border: none;
  border-radius: var(--borderRadius);

  background: var(--orange5);

  color: var(--white);

  font-size: 0.9rem;
  font-weight: 800;

  line-height: 1;

  cursor: pointer;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease;

  span {
    font-size: 1rem;
    transition: transform 0.2s ease;
  }

  &:hover {
    background: var(--orange4);

    transform: translateY(-1px);

    span {
      transform: translateX(2px);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--orange4);
    outline-offset: 3px;
  }
`;
